import React from "react";
import data from "../json/Allproducts/Xpertxpress.json";
import Section1 from "../components/Allproducts/Section1";
import Section5 from "../components/Allproducts/Section5";
import Article from "../components/Allproducts/ArticleSection";
import Features from "../components/Allproducts/FeaturesSection";
import SEO from "../components/SEO";

const xpertXpressSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "XPERT XPRESS",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "XPERT XPRESS is an advanced publishing integrity platform designed to enhance research content and validity. It includes tools to detect plagiarism, citation manipulation, paper mills, and retracted content usage."
  
};


const XpertXpress = () => {
  return (
    <>
    <SEO
        title="XPERT XPRESS | Scientific Research Content & Publishing Integrity Platform"
        description="Enhance publishing integrity with XPERT XPRESS. Detect text and figure plagiarism, citation manipulation, paper mills, tortured phrases, and verify funding or ethics statements seamlessly."
        keywords="XPERT XPRESS, publishing integrity checks, research misconduct detection, plagiarism checker, paper mill finder, citation manipulation, manuscript reference validation, ethical publishing standards, scientific content verification"
        canonical="https://www.transforma.in/products/xpertxpress" // Unggal routing structure-ku thagundhaarpole matrikollunggal
        schema={xpertXpressSchema}
      />
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data} />
      <Features data={data.features} />
      <Article data={data.article} />
      <Section5 data={data.services} />
    </div>
    </>
  );
};

export default XpertXpress;
